export default function SiteLoader() {
  return (
    <div class="flex h-[100vh] w-full justify-center items-center">
      <img
        class="w-auto h-[96px]"
        src='/assets/images/logo.png'
        alt="Loading..."
      />
    </div>
  );
}
